export default __webpack_public_path__ + "static/media/waiter.dcfc4bfe.png";